import React from 'react';
import { Check } from 'lucide-react';
import type { ContentList } from '../types/content';
interface CheckListProps {
  list: ContentList;
}
export function CheckList({
  list
}: CheckListProps) {
  return <div data-id="element-85" data-mp="3cohot88bbj17">
      <h4 className="text-base font-sans font-bold text-navy mb-3" data-id="element-86" data-mp="3co80dp2x1jxm">{list.label}</h4>
      <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2.5" data-id="element-87" data-mp="38ofn4z2kuplx">
        {list.items.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-88" data-mp="33oummk7re973">
            <span className="mt-0.5 w-5 h-5 rounded-full bg-seafoam-light border border-seafoam flex items-center justify-center shrink-0" data-id="element-89" data-mp="33qe0y59uua68">
              <Check size={12} strokeWidth={3} className="text-seafoam-dark" aria-hidden="true" data-id="element-90" data-mp="2tzt8kzkry1vr" />
            </span>
            <span className="text-ink text-sm leading-snug" data-id="element-91" data-mp="2p0zqsuygfops">{item}</span>
          </li>)}
      </ul>
    </div>;
}